module.exports = __webpack_public_path__ + "assets/img/spirit-sub.c390d103.svg";